import type { ChangeEvent, InputHTMLAttributes } from 'react';

import { EStyles } from '@enums/style.enum';

import classes from './Input.module.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	error?: string;
	onTextChange?: (value: string) => void;
	numbersAndLettersOnly?: boolean;
	maxLength?: number;
}

export const Input: React.FC<Props> = ({
	label,
	id,
	error,
	onTextChange,
	numbersAndLettersOnly = false,
	maxLength,
	...props
}: React.PropsWithChildren<Props>) => {
	const _onChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (numbersAndLettersOnly) {
			e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, EStyles.emptyQuote);
		}
		props.onChange?.(e);
		onTextChange?.(e.target.value);
	};

	return (
		<div className={classes['inputContainer']}>
			{label && (
				<label htmlFor={id} className={classes['label']}>
					{label}
				</label>
			)}
			<input
				id={id}
				className={`${classes['input']} ${!!error ? classes['error'] : EStyles.emptyQuote}`}
				autoCorrect={EStyles.off}
				spellCheck={EStyles.false}
				{...props}
				onChange={_onChange}
				maxLength={maxLength ? maxLength : undefined}
			/>
			{error ? <span className={classes['errorMessage']}>{error}</span> : <div className={classes['placeholder']} />}
		</div>
	);
};
